'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (app) {
    app.constant('USER_ROLES', {
        // 所有用户：包括未登录的游客
        all: '*',
        // 管理员
        admin: 'admin',
        // 已登录用户
        common: 'common'
    });
};

; /**
   *  用户角色权限配置
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/USER_ROLES.js
// module id = 32
// module chunks = 0